const routes = [
    {
        name: 'planosParceiro',
        path: '/parceiro/assinaturas',
        alias: [
            '/parceiro/assinaturas/index',
            '/contabilidade/assinaturas',
            '/contabilidade/assinaturas/index',
        ],
        component: () => import('../views/ListarAssinaturas'),
    },
    {
        name: 'contratarAssinaturaParceiro',
        path: '/parceiro/assinaturas/contratar/:clienteId',
        alias: ['/contabilidade/assinaturas/contratar/:clienteId'],
        component: () => import('../views/ContratarAssinatura'),
        meta: { fullScreen: true },
    },
    {
        name: 'assinaturasParceiro',
        path: '/parceiro/assinaturas/renovar_assinaturas',
        alias: [
            '/parceiro/assinaturas/renovar_assinaturas/index',
            '/contabilidade/assinaturas/renovar_assinaturas',
            '/contabilidade/assinaturas/renovar_assinaturas/index',
        ],
        component: () => import('../views/RenovaAssinatura'),
    },
    {
        name: 'visualizarAssinaturaParceiro',
        path: '/parceiro/assinaturas/visualizar/:id',
        alias: [
            '/contabilidade/assinaturas/visualizar/:id',
        ],
        component: () => import('../views/Visualizar'),
    },
    {
        name: 'resumoAssinaturaParceiro',
        path: '/parceiro/assinaturas/resumo/:hash',
        alias: [
            '/contabilidade/assinaturas/resumo/:hash'
        ],
        component: () => import('../views/Resumo'),
    },
    {
        path: '/parceiro/assinaturas/recursos/:id',
        // path: '/parceiro/assinaturas/recursos',
        alias: [
            '/contabilidade/assinaturas/recursos/:id'
        ],
        component: () => import('../views/Recurso'),
    },
    {
        name: 'imprimirBoletoAssinaturaParceiro',
        path: '/assinatura/boleto/?b=:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        name: 'imprimirNfseAssinaturaParceiro',
        path: '/nfse/danfe/:hash',
        alias: [
            'contabilidade/nfse/danfe/:hash',
            'parceiro/nfse/danfe/:hash'
        ],
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    
]

export default routes
